import React, { useCallback } from 'react';
import { useHistory } from "react-router-dom";
import { Logo } from '@images';
import './AppIcon.scss';
import { routes } from '@routes';
import { useClassNames } from '@common';

export interface AppIconProps {
    clickable?: boolean;
}

export const AppIcon = (props: AppIconProps): JSX.Element => {
    const { clickable } = props;
    const history = useHistory();
    const onClick = useCallback(() => {
        if (clickable) {
            history.push(routes.index.path);
        }
    }, [clickable, history]);

    const classNames = useClassNames(
        'app__logo',
        clickable && 'clickable',
    );

    return <div className={classNames} onClick={onClick}>
            <Logo className="app__logo__image" />
        </div>
}